import React, { useState, useRef, useEffect } from "react";
import { CloseButton } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

const TagInput = ({ name, defaultValue }) => {
  const [tags, setTags] = useState([]);
  const inputRef = useRef();

  useEffect(() => {
    if (defaultValue) {
      setTags([...defaultValue]);
    }
  }, [defaultValue]);

  const handleTags = (e) => {
    if (e.keyCode === 13 && inputRef.current.value) {
      let tagsCopy = [...tags];
      tagsCopy.push(inputRef.current.value);
      setTags(tagsCopy);
      inputRef.current.value = null;
    } else if (e.keyCode === 8 && !inputRef.current.value) {
      let tagsCopy = [...tags];
      tagsCopy.pop();
      setTags(tagsCopy);
    }
  };

  const handleDeleteTag = (index) => {
    let tagsCopy = [...tags];
    tagsCopy.splice(index, 1);
    setTags(tagsCopy);
  };

  return (
    <div className="tag-input-wrapper w-100 form-control d-flex flex-row h-auto flex-wrap">
      <div className="tags-wrapper rtl order-1 d-flex flex-wrap">
        {tags?.map((tag, index) => {
          return (
            <div
              key={uuidv4()}
              className="tag-item badge bg-secondary text-white mr-1 font-weight-normal d-flex align-items-center mb-1"
            >
              <CloseButton
                className="text-white ml-1 font-weight-light"
                variant="white"
                onClick={() => handleDeleteTag(index)}
              />
              <span>{tag}</span>
            </div>
          );
        })}
      </div>
      <input
        data-value={[tags]}
        name={name}
        ref={inputRef}
        className="no-border d-block flex-grow-1 border-0 mr-1 order-2"
        onKeyDown={handleTags}
      />
    </div>
  );
};

export default TagInput;
